module.exports = __webpack_public_path__ + "img/icon_submenu21dark.f6501bea.svg";